import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    alpha,
    Box,
    Card,
    CardActionArea,
    CardContent,
    Container,
    Grid,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import { BURSAR_FINANCE_NAV } from "../../config/bursarFinanceNav";
import { getPendingFeeSubmissions } from "../../redux/feeRelated/feeHandle";
import { getSchoolIdForUser } from "../../utils/userContext";
import PendingFeePaymentAlert from "../../components/finance/PendingFeePaymentAlert";

const ICONS = {
    "/Teacher/fees/structures": AccountBalanceOutlinedIcon,
    "/Teacher/fees/collection": AccountBalanceOutlinedIcon,
    "/Teacher/fees/payment-submissions": AccountBalanceOutlinedIcon,
    "/Teacher/fees/defaulters": AccountBalanceOutlinedIcon,
    "/Teacher/fees/reports": AccountBalanceOutlinedIcon,
    "/Teacher/expenses/log": AccountBalanceOutlinedIcon,
    "/Teacher/expenses/budgets": AccountBalanceOutlinedIcon,
    "/Teacher/expenses/summary": AccountBalanceOutlinedIcon,
};

const BursarHomePage = () => {
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.user);
    const { feePaymentSubmissions } = useSelector((state) => state.fee);
    const schoolId = getSchoolIdForUser(currentUser);

    useEffect(() => {
        if (schoolId) dispatch(getPendingFeeSubmissions(schoolId));
    }, [dispatch, schoolId]);

    const pendingCount = Array.isArray(feePaymentSubmissions)
        ? feePaymentSubmissions.filter((row) => row.status === "Pending").length
        : 0;

    return (
        <Box
            sx={{
                minHeight: "100%",
                py: { xs: 2, sm: 3 },
                background: (t) =>
                    t.palette.mode === "light"
                        ? `linear-gradient(180deg, ${alpha(t.palette.success.main, 0.06)} 0%, ${t.palette.grey[50]} 35%)`
                        : alpha(t.palette.common.black, 0.12),
            }}
        >
            <Container maxWidth="lg">
                <Paper elevation={0} sx={{ p: { xs: 2.5, sm: 3 }, borderRadius: 3, mb: 3 }}>
                    <Typography variant="h5" fontWeight={800} gutterBottom>
                        Bursar office
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Welcome, {currentUser?.name || "Bursar"}. Use the menu or the cards below to manage school fees,
                        expenses, and finance reports for {currentUser?.school?.schoolName || "your school"}.
                    </Typography>
                </Paper>

                <PendingFeePaymentAlert
                    count={pendingCount}
                    verifyPath="/Teacher/fees/payment-submissions"
                />

                <Grid container spacing={2}>
                    {BURSAR_FINANCE_NAV.map((item) => {
                        const Icon = ICONS[item.to] || AccountBalanceOutlinedIcon;
                        return (
                            <Grid item xs={12} sm={6} md={4} key={item.to}>
                                <Card variant="outlined" sx={{ borderRadius: 2, height: "100%" }}>
                                    <CardActionArea component={Link} to={item.to} sx={{ height: "100%" }}>
                                        <CardContent>
                                            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                                <Icon color="primary" />
                                                <Box>
                                                    <Typography fontWeight={700}>{item.label}</Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {item.hint}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};

export default BursarHomePage;
